import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const IntlMessage = React.memo((props: any) => (<FormattedMessage {...props} />));
export default injectIntl(IntlMessage, {
  // @ts-ignore
  withRef: false,
});
